import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
type CTAButtonProps = {
  label?: string;
  className?: string;
};
export function CTAButton({
  label = 'Quiero mis clases resueltas',
  className = ''
}: CTAButtonProps) {
  return <a href="#compra" className={`group flex w-full items-center justify-center gap-2 rounded-full bg-[#3f5d4e] px-5 py-4 text-center text-[15px] font-extrabold uppercase tracking-wide text-[#f6f3ec] shadow-lg shadow-[#3f5d4e]/25 transition active:scale-[0.98] hover:bg-[#33503f] focus:outline-none focus-visible:ring-4 focus-visible:ring-[#6f8f7c]/50 ${className}`} data-id="element-67" data-mp="2kzfynalsuofa">
      <span data-id="element-68" data-mp="33o4fnlh5w9ls">{label}</span>
      <ArrowRightIcon className="h-4 w-4 shrink-0 transition group-hover:translate-x-0.5" aria-hidden="true" data-id="element-69" data-mp="33oe8dgtlcuv6" />
    </a>;
}